import { isValidElement, ReactNode } from 'react';

export const extractLabelText = (label: ReactNode): string | undefined => {
    if (typeof label === 'string') {
        return label;
    }

    if (
        isValidElement<{ children?: ReactNode }>(label) &&
        typeof label.props.children === 'string'
    ) {
        return label.props.children;
    }

    return undefined;
};
